export const LOCALE_PICKER_TEST_IDS = {
  root: 'locale-picker-button'
};
